import { useContext, useCallback, useEffect, useState } from "react";
import { Outlet, useSearchParams, useNavigate, useLocation } from "react-router-dom";
import { AuthContext } from "../../../Moduels/Context/AuthContext";
import { hasRole, R } from "../../../rbac/access";
import { fetchActionableLeaveCount } from "../../../Moduels/leave/leaveApi";
import { useLeaveOrg } from "./useLeaveOrg";
import { HrPageShell } from "../../hr/HrDesignSystem";
import "../../../styles/leave-page.css";
import "../../../styles/IndianCalendar.css";

export default function LeaveLayout() {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();
  const { orgId } = useLeaveOrg();
  const { role } = useContext(AuthContext);
  const [actionableCount, setActionableCount] = useState(0);

  const isHolidayPage = location.pathname === "/holiday-calendar";
  const activeTab = isHolidayPage ? "calendar" : (searchParams.get("tab") || "dashboard");

  useEffect(() => {
    if (!orgId || !hasRole(role, [R.ADMIN, R.HR, R.MANAGER])) return;
    fetchActionableLeaveCount(orgId)
      .then((c) => setActionableCount(typeof c === "number" ? c : 0))
      .catch(() => {});
  }, [orgId, role]);

  const handleNavigate = useCallback(
    (id) => {
      if (id === "calendar") {
        navigate("/holiday-calendar");
        return;
      }
      if (id === "dashboard") {
        if (isHolidayPage) navigate("/leave");
        else setSearchParams({});
        return;
      }
      if (isHolidayPage) {
        navigate(`/leave?tab=${id}`);
      } else {
        setSearchParams({ tab: id });
      }
    },
    [navigate, setSearchParams, isHolidayPage]
  );

  return (
    // Same shell as AttendanceLayout so both modules share background and spacing.
    <HrPageShell className="lv-root !p-0">
      <Outlet context={{ activeTab, setTab: handleNavigate, actionableCount }} />
    </HrPageShell>
  );
}
